import React from 'react';
import axsLogo from './assets/marketplace-logos/axs.png';
import fanxchangeLogo from './assets/marketplace-logos/fanxchange.png';
import gametimeLogo from './assets/marketplace-logos/gametime.png';
import goTicketsLogo from './assets/marketplace-logos/gotickets.png';
import seatGeekLogo from './assets/marketplace-logos/seatgeek.png';
import stubHubLogo from './assets/marketplace-logos/stubhub.png';
import ticketEvolutionLogo from './assets/marketplace-logos/ticketevolution.png';
import ticketMasterLogo from './assets/marketplace-logos/ticketmaster.png';
import ticketNetworkLogo from './assets/marketplace-logos/ticketnetwork.png';
import ticketsNowLogo from './assets/marketplace-logos/ticketmaster.png';
import tickPickLogo from './assets/marketplace-logos/tickpick.png';
import vividSeatsLogo from './assets/marketplace-logos/vividseats.png';
import {
  getMarketplaceDeepLinks,
} from './marketplaceDeepLinks';

type Props = {
  stubhubId?: string | null;
  seatgeekId?: string | null;
  ticketmasterId?: string | null;
  vividSeatsId?: string | null;
  eventApiUrl?: string | null;
  eventName?: string | null;
  eventDate?: string | null;
  venue?: string | null;
  className?: string;
  linkClassName?: string;
  disabledClassName?: string;
  stubhubClassName?: string;
  seatgeekClassName?: string;
  ticketmasterClassName?: string;
  vividseatsClassName?: string;
};



/** Shared marketplace logo for event links, selection grids, and table chips. */
export function MarketplaceBrandMark({ id, size = 18 }: { id: string; size?: number }) {
  const logo = MARKETPLACE_LOGOS[id.trim().toLowerCase()];
  if (!logo) return null;

  return (
    <img
      src={logo}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      style={{ display: 'block', width: size, height: size, objectFit: 'contain', flexShrink: 0 }}
    />
  );
}

const MARKETPLACE_LOGOS: Record<string, string> = {
  axs: axsLogo,
  fanxchange: fanxchangeLogo,
  fanx: fanxchangeLogo,
  gametime: gametimeLogo,        // green G logo
  gotickets: goTicketsLogo,
  seatgeek: seatGeekLogo,
  stubhub: stubHubLogo,
  ticketevolution: ticketEvolutionLogo,
  ticketmaster: ticketMasterLogo,
  ticketnetwork: ticketNetworkLogo,
  ticketsnow: ticketsNowLogo,
  tickpick: tickPickLogo,
  vivid: vividSeatsLogo,         // pink/purple V logo
  vividseats: vividSeatsLogo,    // pink/purple V logo
};/** Marketplace links use the shared event-link builder. */
export function EventMarketplaceDeepLinks({
  stubhubId,
  seatgeekId,
  ticketmasterId,
  vividSeatsId,
  eventApiUrl,
  eventName,
  eventDate,
  venue,
  className,
  linkClassName,
  disabledClassName,
  stubhubClassName,
  seatgeekClassName,
  ticketmasterClassName,
  vividseatsClassName,
}: Props) {
  const classNamesById: Record<string, string | undefined> = {
    stubhub: stubhubClassName,
    seatgeek: seatgeekClassName,
    ticketmaster: ticketmasterClassName,
    vividseats: vividseatsClassName,
  };
  const links = getMarketplaceDeepLinks({
    stubhubId,
    seatgeekId,
    ticketmasterId,
    vividSeatsId,
    eventApiUrl,
    eventName,
    eventDate,
    venue,
  });
  const items = links.map((link) => ({
    id: link.id,
    label: link.label,
    href: link.href,
    icon: <MarketplaceBrandMark id={link.id} size={18} />,
    brandClassName: classNamesById[link.id],
  }));

  return (
    <div className={className} onClick={(e) => e.stopPropagation()}>
      {items.map((item) => {
        const classNames = [linkClassName, item.brandClassName].filter(Boolean).join(' ');
        if (item.href) {
          return (
            <a
              key={item.id}
              className={classNames}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              title={`Open event on ${item.label}`}
              aria-label={`Open event on ${item.label}`}
            >
              {item.icon}
            </a>
          );
        }
        return (
          <span
            key={item.id}
            className={[classNames, disabledClassName].filter(Boolean).join(' ')}
            title={`${item.label} link not available`}
            aria-label={`${item.label} link not available`}
            aria-disabled="true"
          >
            {item.icon}
          </span>
        );
      })}
    </div>
  );
}
